import React from 'react';
import { motion } from 'framer-motion';
import australia from '../assets/destinations/australia.png';

const Destinations = () => {
  return (
    <section className="py-20 px-4 sm:px-10 lg:px-20 bg-white">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center max-w-3xl mx-auto"
      >
        <h1 className="text-4xl font-bold text-blue-700 mb-4">Study in Australia</h1>
        <p className="text-lg text-gray-700 leading-relaxed">
          Australia offers world-class education, stunning landscapes, a welcoming multicultural society, and excellent career prospects.
          Whether you're aiming for a top university, professional growth, or post-study work rights, Australia is a smart choice.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="mt-12 flex flex-col md:flex-row items-center gap-10 max-w-5xl mx-auto"
      >
        <img
          src={australia}
          alt="Australia"
          className="w-64 h-auto rounded-xl shadow-lg border border-blue-200"
        />

        <ul className="text-left text-gray-700 text-lg space-y-4">
          <li>🎓 Globally ranked universities</li>
          <li>💼 Post-study work visas (485 Visa)</li>
          <li>🌐 Multicultural & safe environment</li>
          <li>📚 Flexible study options and intakes</li>
          <li>🛫 Smooth visa process with our Assist</li>
        </ul>
      </motion.div>
    </section>
  );
};

export default Destinations;
